// Recent assistant conversations. Resume on click; "New conversation" clears
// the composer. Workspace-agnostic — these are private to their creator.
import { Button, Group, Stack, Text, UnstyledButton } from "@mantine/core";
import { IconMessage, IconPlus } from "@tabler/icons-react";

import type { AssistantConversation } from "@/api/assistant";

interface Props {
  conversations: AssistantConversation[];
  activeConversationId: string | null;
  onSelect: (id: string) => void;
  onNew: () => void;
}

export function AssistantConversationList({
  conversations,
  activeConversationId,
  onSelect,
  onNew,
}: Props) {
  return (
    <Stack gap="sm" h="100%">
      <Button
        variant="light"
        leftSection={<IconPlus size={16} />}
        onClick={onNew}
        fullWidth
      >
        New conversation
      </Button>

      {conversations.length === 0 ? (
        <Text size="sm" c="dimmed" ta="center" mt="md">
          No conversations yet.
        </Text>
      ) : (
        <Stack gap={4} style={{ overflowY: "auto" }}>
          {conversations.map((c) => {
            const isActive = c.id === activeConversationId;
            return (
              <UnstyledButton
                key={c.id}
                onClick={() => onSelect(c.id)}
                p="xs"
                style={{
                  borderRadius: 8,
                  backgroundColor: isActive ? "var(--mantine-color-blue-light)" : undefined,
                }}
              >
                <Group gap="xs" wrap="nowrap">
                  <IconMessage size={16} color="var(--mantine-color-gray-6)" style={{ flexShrink: 0 }} />
                  <Text size="sm" truncate fw={isActive ? 500 : 400}>
                    {c.title || "Untitled conversation"}
                  </Text>
                </Group>
              </UnstyledButton>
            );
          })}
        </Stack>
      )}
    </Stack>
  );
}
